export const loadScript = (src, cb = () => {}) => {
    const script = document.createElement('script');
    script.src = src;
    script.onload = cb;

    document.querySelector('body').appendChild(script);
};
